import { SuretyAccountId, SuretyType } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountLatestUnderwritingQueryKey, accountQueryKey } from "../account.keys";

export const useAdminUnderwrite = (accountId: SuretyAccountId, suretyType: SuretyType) => {
	const { put } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: async () => {
			await put(`/v2/admin/surety/accounts/${accountId}/underwrite?suretyType=${suretyType}`);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) });
			queryClient.invalidateQueries({
				queryKey: accountLatestUnderwritingQueryKey(accountId),
			});
		},
	});

	return {
		updateUnderwriting: mutation.mutate,
		updateUnderwritingIsLoading: mutation.isPending,
		updateUnderwritingError: mutation.error,
		updateUnderwritingSuccess: mutation.isSuccess,
		resetUnderwrite: mutation.reset,
	};
};
